<template>
  <div>
    <x-dialog-comp title="流量监测" @on-close="$emit('on-close')">
        <x-title-btn :menu-data.sync="titleMenuData"></x-title-btn>
        <x-real-time v-if="titleMenuData[0].checkType" :device-id="deviceId"></x-real-time>
        <x-history v-if="titleMenuData[1].checkType" :device-id="deviceId" ></x-history>
        <x-details v-if="titleMenuData[2].checkType" :res-data="resData"></x-details>
        <div v-if="titleMenuData[3].checkType" class="x-aq-cnt">
          <x-an-quan-fen-xi></x-an-quan-fen-xi>
        </div>
    </x-dialog-comp>
  </div>
</template>

<script>
import XDialogComp from "@/components/x-dialog-comp";
import XTitleBtn from "@/components/x-title-btn";
import XRealTime from "@/components/x-device-LiuLiang/components/x-real-time";
import XDetails from "@/components/x-device-osmoticPressure-dialog/components/x-details";
import XAnQuanFenXi from "@/components/x-AnQuanFenXi";
import {getOsmoticPressure} from "@/api/device/osmoticPressure";
import XHistory from "@/components/x-device-osmoticPressure-dialog/components/x-history";

export default {
  name: "x-device-LiuLiang",
  components: {XHistory, XAnQuanFenXi, XDetails, XRealTime, XDialogComp, XTitleBtn},
  props: {
    deviceId: "",
  },
  data() {
    return {
      loadingType: false,
      resData: {},
      titleMenuData: [
        {
          checkType: true,
          name: '实时数据',
        }, {
          checkType: false,
          name: '历史数据',
        }, {
          checkType: false,
          name: '设备详情',
        }, {
          checkType: false,
          name: '安全研判',
        }
      ],
    }
  },
  created() {
    this.initData();
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {


  },
}
</script>

<style scoped>

.x-aq-cnt {
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
